import { BannerMessageVariant } from '@amobee/component-library';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { MessageService } from './message.service';

@Injectable()
export class PromotionService {

    promotionRoutes = [
        'campaign',
        'creative'
    ];

    constructor(
        private miscAdapter: MiscAdapter,
        private messageService: MessageService,
        private router: Router,
    ) { }

    getPromotion() {
        let subscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (this.promotionRoutes.some(url => this.router.isActive(url, false))) {
                this.miscAdapter.getPromotion().then((promotion) => {
                    let now = new Date();
                    if (promotion && promotion.message && promotion.message.length > 0 && promotion.valid_to && promotion.valid_to.getTime() > now.getTime()) {
                        this.messageService.sendNotification(promotion.message, BannerMessageVariant.INFO, 0, false, true);
                    }
                }).finally(() => {
                    // only show once
                    subscription.unsubscribe();
                });
            }
        });
    }


}
